import { AfterViewInit, Component, Input, ViewChild } from "@angular/core"
import { BsModalService } from "ngx-bootstrap/modal"
import { Lightbox, LightboxConfig } from "ngx-lightbox"
import { Subscription, timer } from "rxjs"
import { ScoutPath, ScoutPoint, ScoutPointPhoto } from "../../../core/models"
import { ScoutPointPhotoDoc } from "../../../core/schema/scout-point-photo-schema"
import { ScoutTaskDoc } from "../../../core/schema/scout-task-schema"
import { ScoutPointPhotoService } from "../../../core/services"
import { ConfirmModalComponent } from "../../../shared/components/confirm-modal/confirm-modal.component"
import { ScoutPhotoGroupDef } from "../scout-point-photo-browser/scout-point-photo-browser.component"
import { ScoutPointPhotoEditorComponent } from "../scout-point-photo-editor/scout-point-photo-editor.component"



@Component({
    selector: 'modal-content',
    templateUrl: './scout-point-photo-modal.component.html',
    styleUrls: ['./scout-point-photo-modal.component.scss']
  })
  export class ScoutPointPhotoModal implements AfterViewInit {

    static readonly ModalId = 2099

    @Input() task : ScoutTaskDoc
    @Input() path : ScoutPath
    @Input() point : ScoutPoint
    @Input() photo : ScoutPointPhotoDoc
    @Input() locked : boolean = false
    @Input() photos : ScoutPointPhotoDoc[] = []
    @Input() photoGroup : { title: string, photos: ScoutPointPhotoDoc[] }
    @ViewChild('editor') editor: ScoutPointPhotoEditorComponent;

    groupTitle : string
    groupIndex : number
    groupSize : number
    index : number
    //photoSaveSubscription : Subscription
    

    constructor( private modalService: BsModalService,
      private photoService: ScoutPointPhotoService,
      private lightbox: Lightbox,
      lightboxConfig: LightboxConfig ) {
        lightboxConfig.fitImageInViewPort = true
        lightboxConfig.showRotate = true
        lightboxConfig.showZoom = true
        lightboxConfig.fadeDuration = 0.4
    }


    ngAfterViewInit(): void {
      this.init()
    }
  

    async askDiscardEdits(acceptDiscardFn: () => void) {
      let initialState = {
        onYes: ()=>{ 
          timer(100).subscribe( _ => acceptDiscardFn() )
        },
        question: 'Discard scout photo changes?',
        focusOnNo: true,
        yesStyle: 'btn btn-danger'
      }
      this.modalService.config.animated = false
      this.modalService.show(ConfirmModalComponent, { initialState });
    }


    // remove a "new" photo from the collections it was temporarily added 
    // TODO - probably should be replaced by the emitting of a cancel event so real owners of collections can remove it
    cancelPhoto( photo : ScoutPointPhoto ) {
      if ( photo && !photo._id && ['point-to-point','additional'].includes(photo.group)) {
        const index = this.photos.findIndex(p=>p==photo)
        if ( index != -1 ) {
          this.photos.splice(index,1)
        }
        const groupPhotoIndex = this.photoGroup?.photos.findIndex(p=>p==photo)
        if ( groupPhotoIndex != -1 ) {
          this.photoGroup?.photos.splice(groupPhotoIndex,1)
        }
      }
    }


    init(){
      //this.photoSaveSubscription?.unsubscribe()
      if ( this.photo ) {
        //this.photoSaveSubscription = this.editor.savedEmitter.subscribe(photo=>{})
        if ( this.photo.group == 'measurement') {
          this.groupTitle = 'Measurement'
        } else if (this.photo.group == 'wide-angle') {
          this.groupTitle = 'Wide-Angle'
        } else if (this.photo.group == 'point-to-point') {
          this.groupTitle = 'Path View'
        } else if (this.photo.group == 'additional') {
          this.groupTitle = 'Additional'
        } else {
          this.groupTitle = this.photo.group
        }
      }
  
      if ( !this.photoService.compatibleCameras?.length ) {      
        this.photoService.updateCompatibleCameras()
      }
  
      this.index = this.photos?.findIndex(p=>p==this.photo)
      const grpPhotos = this.photos?.filter(p=>p.group==this.photo?.group)
      this.groupSize = grpPhotos.length
      const grpIndex = grpPhotos.findIndex(p=>p==this.photo)
      this.groupIndex = grpIndex
    }


    isModified = () => {
      if ( this.editor?.photoForm?.dirty ) {
        return true
      } else {
        const bNewAndUnsavedPhoto = this.photo && !this.photo._id && ['point-to-point','additional'].includes(this.photo.group)
        return bNewAndUnsavedPhoto
      }
    }


    onCloseModal = () => {
      const closeFn = () => { 
        if ( this.photo && !this.photo._id ) {
          this.cancelPhoto(this.photo)
        }
        this.modalService.hide(ScoutPointPhotoModal.ModalId)
      }
      if ( !this.isModified() ) {
        closeFn()
      } else {
        this.askDiscardEdits(closeFn)
      }
    }


    async onNextPhoto( indexOffset : number ) {
      const nextFn = async () => { 
        const lastPhoto = this.photo
        const index = this.photos.findIndex(p=>p==this.photo)
        this.photo = this.photos[index+indexOffset]
        if ( lastPhoto && !lastPhoto._id ) {
          this.cancelPhoto(lastPhoto)
        }
        this.editor?.uploadProgressSubscription?.unsubscribe()
        this.editor?.downloadProgressSubscription?.unsubscribe()
        this.init()
      }
      if ( !this.isModified() ) {
        nextFn()
      } else {
        this.askDiscardEdits(nextFn)
      }
    }
  
  
    onPhotoClick = ( photo : ScoutPointPhoto, photoUrl : string ) => {
      if ( !this.editor?.photoUrl ) {
        return
      }
      const album = {
        src: this.editor.photoUrl, 
        thumb: null, 
        caption: this.editor.photo?.title + ' (' + this.editor.photo?.fileName + ')',
        photo: this.editor.photo
      }
      this.lightbox.open([album],0)
    }
    

    async onSave() {
      try {      
        await this.editor.onSave()
      } catch ( error ) {
        console.error('Failed saving photo doc')
      }
    }
  
}